import React from 'react';

// Catches a failure while loading/rendering a 3D scene (e.g. a texture that fails to download)
// so the visitor gets a message and a way back instead of a blank or crashed page.
export default class SceneErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }
  static getDerivedStateFromError() {
    return { failed: true };
  }
  componentDidCatch(error) {
    console.error('Scene failed to load:', error);
    this.props.onError?.(error);
  }
  render() {
    return this.state.failed ? null : this.props.children;
  }
}
